import { render, staticRenderFns } from "./AnnouncementSetting.vue?vue&type=template&id=07376a5f&"
import script from "./AnnouncementSetting.vue?vue&type=script&lang=js&"
export * from "./AnnouncementSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports